import { Component, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn } from "../../../Componente/DataGridView";
import { LeitsetlleEdit } from "../../Controlls/EditViews/LeitsetlleEdit";
import { ArtikelEdit } from "../../Controlls/EditViews/ArtikelEdit";
import { Artikel } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { PopUpView } from "../../../Componente/PopUpView";


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, ArtikelEdit, PopUpView
  ],
  selector: 'ArtikelList',
  templateUrl: './ArtikelList.html',
  standalone: true,
  styleUrl: './ArtikelList.css'
})
export class ArtikelList {
  @ViewChild('Grid') childComponent!: DataGridView<Artikel>;

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }
}
